module.exports = __webpack_public_path__ + "a23c2ef054809cf4332ecd0c6d096021.pdf";